import { render, staticRenderFns } from "./ArticleSix.vue?vue&type=template&id=cd622478&scoped=true"
import script from "./ArticleSix.vue?vue&type=script&lang=js"
export * from "./ArticleSix.vue?vue&type=script&lang=js"
import style0 from "./ArticleSix.vue?vue&type=style&index=0&id=cd622478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd622478",
  null
  
)

export default component.exports